// extracted by mini-css-extract-plugin
export var closeButton = "_32-3";
export var header = "_32-0";
export var link = "_32-1";
export var retryButton = "_32-2";